import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';

import Login from '../Login';
import { selectIsUserAuthenticated } from '../Auth/selector';
import { setUser } from '../Auth/slice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


const Logout = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isUserAuthenticated = useSelector(selectIsUserAuthenticated);
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    localStorage.removeItem('token');
    setOpen(false);
    history.push('/login');
  }

  if (isUserAuthenticated) {
    dispatch(setUser(null));
    return null;
  }

  return (
    <>
      <Login />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="logout-modal"
        aria-describedby="logout-modal-description"
      >
        <Box sx={style}>
          <Typography id="logout-modal" variant="h6" component="h2">
            Bye!
          </Typography>
          <Typography id="logout-modal-description" sx={{ mt: 2 }}>
            You have been successfully logged out!
          </Typography>
        </Box>
      </Modal>
    </>
  )
};

export default Logout;
